export default "__VITE_ASSET__ulHxfOM2__"